<template>
    <app-modal-view @close="$emit('close')">
        <template #body>
            <div class="lb-project-modal-content px-6">
                <div class="columns" >
                    <div class="column is-6 is-offset-3">
                        <div class="control has-icons-left lb-join-input">
                            <input
                                v-model="code"
                                :placeholder="$t('Sessions.join_placeholder')"
                                class="input is-medium is-uppercase is-size-2 pl-6"
                                type="text"
                            />
                            <span class="icon is-left is-small is-size-4 has-text-black pt-5">
                                <i class="fas fa-key" aria-hidden="true" />
                            </span>
                            <button
                                :class="{
                                    'is-loading': joiningSession,
                                    'is-danger': joinError,
                                }"
                                class="button is-primary my-2"
                                @click="joinSession"
                            >{{ $t('Sessions.join').toUpperCase() }}</button>
                        </div>
                    </div>
                </div>

                <div class="px-3 pt-4">
                    <p
                        v-if="gameExpired"
                        v-t="'Sessions.expired'"
                        class="title has-text-centered is-6"
                    ></p>
                    <p
                        v-if="gameNotStarted"
                        v-t="'Sessions.not_started'"
                        class="title has-text-centered is-6"
                    ></p>
                    <p
                        v-if="gameGeoMode"
                        v-t="'Sessions.invalid_mode'"
                        class="title has-text-centered is-6"
                    ></p>

                    <p
                        v-if="invalidCode"
                        v-t="'Sessions.invalid_code'"
                        class="title has-text-centered is-6"
                    ></p>

                    <p
                        class="is-6"
                    >{{ $t('Sessions.join_session_description') }}</p>
                </div>
            </div>
        </template>
    </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
import { joinSession } from '@/services/API';
export default {
    components: {
        AppModalView,
    },
    data() {
        return {
            code: this.$route.query.code,
            joiningSession: false,
            joinError: false,
            gameExpired: false,
            gameNotStarted: false,
            gameGeoMode: false,
            invalidCode: false
        };
    },
    watch: {
        code() {
            if (!this.code.length) {
                this.joinError = false;
            }
        },
    },
    methods: {
        async joinSession() {
            if (!this.code) {
                return;
            }
            this.joiningSession = true;
            this.joinError = false;
            this.gameExpired = false;
            this.gameNotStarted = false;
            this.invalidCode = false;
            const response = await joinSession(this.code.toUpperCase())
                .catch((e) => {
                    this.joinError = true;
                    if (e.data.error == 'SESSION_EXPIRED') {
                        this.gameExpired = true;
                    } else if (e.data.error == 'SESSION_NOT_STARTED') {
                        this.gameNotStarted = true;
                    }else if (e.data.error == 'SESSION_NOT_FOUND'){
                        this.invalidCode = true;
                    }
                })
                .finally(() => {
                    this.joiningSession = false;
                });

            if (response && response.data) {
                this.joiningSession = false;
                const session = response.data;
                // permitir jugar desde web a las partidas tipo mapa
                /*if (
                    session.configuration.mode == 'MAP' &&
                    session.project.type.toUpperCase() == 'TRIVIAL'
                ) {
                    this.joinError = true;
                    this.gameGeoMode = true;
                    return;
                }*/
                this.$store.dispatch('setSession', session);
                this.$router.replace({
                    name: 'play',
                    query: { code: this.code },
                });
                this.$emit('close');
                this.$emit('join', { code: this.code });
            }
        },
        
    },
};
</script>

<style scoped>
.lb-join-input input {
    height: 2em;
}
.lb-join-input button {
    width: 100%;
}
.lb-text-underline {
    text-decoration: underline;
}
</style>